import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import FieldGroup from '../FieldGroup';
import './input.css';

const renderFieldGroup = field => {
	return (
		<FieldGroup field={field}>
			<input className="input" {...field.custom} {...field.input} type={field.type} />
		</FieldGroup>
	)
}

const InputFieldGroup = ({ label, name, type, ...custom}) => {
	return (
		<Field 
			label={label}
			name={name}
			type={type}
			component={renderFieldGroup}
			{...custom}
		/>
	)
}

InputFieldGroup.propTypes = {
	label: PropTypes.string,
	name: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	custom: PropTypes.object,
}

InputFieldGroup.defaultProps = {
	type: 'text'
}

export default InputFieldGroup;


// WEBPACK FOOTER //
// ./src/components/common/form/InputFieldGroup/index.js